export const GET_COURSE_UNITS = "GET_COURSE_UNITS"
export const GET_COURSE_UNITS_FAIL = "GET_COURSE_UNITS_FAIL"
export const GET_COURSE_UNITS_SUCCESS = "GET_COURSE_UNITS_SUCCESS"

export const ADD_NEW_COURSE_UNIT = "ADD_NEW_COURSE_UNIT"
export const ADD_COURSE_UNIT_SUCCESS = "ADD_COURSE_UNIT_SUCCESS"
export const ADD_COURSE_UNIT_FAIL = "ADD_COURSE_UNIT_FAIL"

export const UPDATE_COURSE_UNIT = "UPDATE_COURSE_UNIT"
export const UPDATE_COURSE_UNIT_SUCCESS = "UPDATE_COURSE_UNIT_SUCCESS"
export const UPDATE_COURSE_UNIT_FAIL = "UPDATE_COURSE_UNIT_FAIL"

export const DELETE_COURSE_UNIT = "DELETE_COURSE_UNIT"
export const DELETE_COURSE_UNIT_SUCCESS = "DELETE_COURSE_UNIT_SUCCESS"
export const DELETE_COURSE_UNIT_FAIL = "DELETE_COURSE_UNIT_FAIL"





